import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="bg-[#1a1a2e] py-20 px-6">
      <div className="max-w-[760px] mx-auto text-center">
        <h2 className="text-3xl xl:text-4xl font-bold text-white mb-4 leading-snug">
          VergeOS&apos;u Canlı Görün
        </h2>
        <p className="text-sm text-gray-400 leading-relaxed mb-10 max-w-md mx-auto">
          Mimari ekibimizle 25 dakikalık teknik bir sunum planlayın.
          Satış konuşması yok. Sadece altyapı sorularınıza yanıtlar.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/iletisim"
            className="inline-flex items-center justify-center gap-2 bg-[#e8600a] text-white font-semibold px-7 py-3.5 rounded-md hover:bg-[#cc5208] transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-calendar-check-line"></i>
            Teknik Sunum Planla
          </Link>
        </div>
      </div>
    </section>
  );
}